import { ReactElement } from 'react';
import { HomepageSlice } from '@adapters/prismic/types/homepage';
import { PageType } from '@adapters/prismic/types/slices';
import HomepageSliceHandler from '../HomepageSliceHandler';
import { AlgonomyPlacement } from '@components/global/Recommendations';

import styles from './HomepageSliceZone.module.scss';

export interface HomepageSliceZoneProps {
  slices: HomepageSlice[];
  pageType: PageType;
  secondSliceZone?: boolean;
  recommendations?: AlgonomyPlacement[];
}

const HomepageSliceZone = ({
  slices,
  pageType,
  secondSliceZone,
  recommendations,
}: HomepageSliceZoneProps): ReactElement => (
  <div>
    {slices?.map((slice, i) => (
      <section className={styles.homepageSlice} key={`homepage-slice-${i}`}>
        <HomepageSliceHandler
          slice={slice}
          pageType={pageType}
          sliceIndex={i}
          secondSliceZone={secondSliceZone}
          recommendations={recommendations}
        />
      </section>
    ))}
  </div>
);

export default HomepageSliceZone;
